import React, { createContext } from "react";
const DataContext = createContext();
export default DataContext;
